import React, { useEffect, useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import StatusPill from '../components/StatusPill';

export default function Profile() {
  const { apiUrl, currentUser } = useOutletContext();
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${apiUrl}/api/learning/certificates`, { credentials: 'include' })
      .then((response) => (response.ok ? response.json() : []))
      .then(setCertificates)
      .finally(() => setLoading(false));
  }, [apiUrl]);

  return (
    <section className="forge-page profile-page">
      <div className="forge-page-header">
        <div>
          <div className="forge-section-eyebrow">Perfil FORGE</div>
          <h1 className="forge-title">@{currentUser?.username || 'usuario'}</h1>
          <p className="forge-lead">Rol, aprendizaje y credenciales internas verificables.</p>
        </div>
        <div className="profile-role-pills" aria-label="Roles asignados">
          {(currentUser?.roles || []).map((role) => <StatusPill key={role} color="blue">{role}</StatusPill>)}
          {!currentUser && <StatusPill color="blue">Cargando</StatusPill>}
        </div>
      </div>

      <section className="forge-panel profile-learning">
        <div className="learning-section-head">
          <div><div className="forge-section-eyebrow">Aprendizaje</div><h2>Certificaciones</h2></div>
          <Link className="forge-button" to="/learn">Continuar aprendiendo</Link>
        </div>
        {loading ? <p>Cargando credenciales…</p> : certificates.length ? (
          <div className="profile-certificates">
            {certificates.map((certificate) => (
              <article key={certificate.verification_code}>
                <div className="profile-certificate-mark">✓</div>
                <div>
                  <strong>Tronco común FORGE · v{certificate.curriculum_version}</strong>
                  <p>Emitida {new Date(certificate.issued_at).toLocaleDateString('es-MX')}</p>
                  <small>{certificate.verification_code}</small>
                </div>
                <StatusPill color={certificate.is_current ? 'green' : 'blue'}>
                  {certificate.is_current ? 'Vigente' : 'Histórica'}
                </StatusPill>
                <Link className="forge-button" to={`/certificates/verify/${certificate.verification_code}`}>Verificar</Link>
              </article>
            ))}
          </div>
        ) : <div className="forge-empty profile-certificates-empty"><strong>Aún no tienes certificaciones.</strong><span>Completa la ruta Aprender para obtener la primera.</span></div>}
      </section>
    </section>
  );
}
